import {BaseApi, HttpMethodEnum} from '../BaseApi/BaseApi';
import {IMedicalNote} from '../../entities/MedicalNote/MedicalNote';

export class MedicalNotesApi extends BaseApi {
    private static baseApiUrl: string = `${BaseApi.apiUrl}/Patients`;

    public static apiUrls = {
        getMedicalNote: `${MedicalNotesApi.baseApiUrl}/:id/MedicalNote`,
        putMedicalNote: `${MedicalNotesApi.baseApiUrl}/:id/MedicalNote`,
    };

    public static async getMedicalNote(patientId: string): Promise<IMedicalNote> {
        return this.sendApiRequest<IMedicalNote>({
            method: HttpMethodEnum.GET,
            path: this.apiUrls.getMedicalNote,
            data: undefined,
            id: patientId
        });
    }

    public static async updateMedicalNote(patientId: string, data: IMedicalNote): Promise<boolean> {
        return this.sendApiRequest<boolean>({
            method: HttpMethodEnum.PUT,
            path: this.apiUrls.putMedicalNote,
            data: data,
            id: patientId
        });
    }
} 